import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en/translation.json';
import arTranslation from './locales/ar/translation.json';

const resources = {
  en: {
    translation: enTranslation
  },
  ar: {
    translation: arTranslation
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar'],
    debug: false,
    // Normalize regional variants (e.g. 'ar-SA', 'ar-EG') down to 'ar'/'en'.
    // Without this, i18n.language can end up as 'ar-SA' after browser
    // auto-detection, which breaks every `i18n.language === 'ar'` RTL check
    // across the app even though translated text still renders correctly.
    load: 'languageOnly',

    interpolation: {
      escapeValue: false
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      // Applied to whatever each detector method returns (including a
      // previously-cached bad value in localStorage), so this both fixes
      // new visits and self-heals sessions already stuck on e.g. 'ar-SA'.
      convertDetectedLanguage: (lng) => lng.split('-')[0]
    }
  });

export default i18n;
